<template>
  <div class="mb-96">
    <div
      class="text-center text-white text-xl flex flex-col space-y-2 tracking-normal leading-relaxed px-4"
    >
      <p class="font-medium">
        Add liquidity to the different pairs to earn MUSE.
      </p>

      <p class="font-light max-w-4xl mx-auto pt-4">
        $MUSE can be used for specific votes on the platform, or you can sell
        $MUSE on
        <a
          href="https://info.uniswap.org/pair/0x20d2c17d1928ef4290bf17f922a10eaa2770bf43"
          target="_blank"
          class="text-yellow-300 hover:underline hover:text-primary"
        >
          uniswap
        </a>
      </p>
      <p>
        For additional projects to get farming rewards, check out our
        <a
          href="https://snapshot.org/#/nft20.eth/proposal/QmP19j9MRApzKumYWnivWS9iE6kpPh935zz7pKznjUSHyn"
          target="_blank"
          class="text-yellow-300 hover:underline hover:text-primary"
        >
          LP Farming Framework
        </a>
      </p>
    </div>

    <div
      v-if="isLoaded"
      class="flex flex-col space-y-4 justify-center items-center mt-10"
    >
      <FarmCardNFT20
        symbol="MUSE"
        address="0x20d2c17d1928ef4290bf17f922a10eaa2770bf43"
        poolid="0"
        dailyRewards="250"
      />

      <FarmCardNFT20
        symbol="MASK20"
        address="0xaa617c8726adfde9e7b08746457e6b90ddb21480"
        poolid="5"
        dailyRewards="31.25"
      />

      <FarmCardNFT20
        symbol="MCAT20"
        address="0x31c507636a4cab752a8a069b865099924bd5f1a9"
        poolid="9"
        dailyRewards="31.25"
      />

      <FarmCardNFT20
        symbol="CHUBBIES20"
        address="0x75eFD92Ff443c3D3342eaA64Dd32Be387F5ef328"
        poolid="10"
        dailyRewards="15.6"
      />

      <FarmCardNFT20
        symbol="DUDES20"
        address="0x04914cb01eec94e320e3a88b3c7a7e9b1609d13c"
        poolid="6"
        dailyRewards="31.25"
      />

      <FarmCardNFT20
        symbol="ROPE20"
        address="0x95acf4ba2c53e31db1459172332d52baac433bb3"
        poolid="7"
        dailyRewards="31.25"
      />

      <!-- BGAN Punks -->
      <FarmCardNFT20
        symbol="GPUNKS20"
        address="0xbb1565072fb4f3244ebce5bc8dfeda6baeb78ad3"
        poolid="8"
        dailyRewards="31.25"
      />
      <FarmCardNFT20
        symbol="MEME20"
        address="0xE14f1283059afA8d3c9c52EFF76FE91854F5D1B3"
        poolid="4"
        dailyRewards="31.25"
      />
      <FarmCardNFT20
        symbol="NDR20"
        address="0x8d816f2c4132fbba4170adfaac772d3ae52fd1db"
        poolid="1"
        dailyRewards="15.6"
        :warn="true"
      />
      <FarmCardNFT20
        symbol="Doki20"
        address="0x68b049C8BD1d8b20814B41c73A73aB126C19B42e"
        poolid="2"
        dailyRewards="31.25"
        :warn="true"
      />

      <div
        class="text-center text-white text-xl flex flex-col space-y-2 tracking-wide leading-loose"
      >
        Old (remove your funds as these farms are not active)
      </div>
      <FarmCard />
      <FarmCardNFT20
        symbol="Chonk20"
        address="0xe775bad5df325f53278288a41cbc8b32ab2217bc"
        poolid="3"
        dailyRewards="0"
      />
    </div>
  </div>
</template>

<style scoped>
::placeholder {
  color: white;
  opacity: 0.7;
}
</style>
<script>
import FarmCard from "@/components/FarmCard.vue";
import FarmCardNFT20 from "@/components/FarmCardNFT20.vue";

export default {
  name: "Farm",
  components: { FarmCard, FarmCardNFT20 },
  data: function () {
    return {
      search: "",
    };
  },
  methods: {
    onAssetClick: function (contract) {
      this.$router.push({ name: "Asset", params: { pair: contract } });
    },
    onAddAssetClicked: function () {
      this.$router.push({ name: "Create", params: {} });
    },
  },
  computed: {
    projects: function () {
      return this.$store.state.pairs;
    },
    isLoaded: function () {
      return this.$store.state.isLoaded;
    },
    filteredList() {
      return this.$store.state.pairs.filter((asset) => {
        return asset.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>
